





















































































































































import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { mixins } from 'vue-class-component'
import { VFormType } from '@/types/v-form-type'
import FormCard from '@/components/form/FormCard.vue'
import IconWithText from '@/components/form/IconWithText.vue'
import ContactNumberField from '@/components/form/ContactNumberField.vue'
import TextField from '@/components/form/TextField.vue'
import SelectField from '@/components/form/SelectField.vue'
import validationMixin from '@/mixins/validation-mixin'
import verificationStepMixin from '@/mixins/verification-step-mixin'
import screenSizeMixin from '@/mixins/screen-size-mixin'

const ProfileModule = namespace('profileStore')

@Component({
  components: {
    FormCard,
    IconWithText,
    TextField,
    ContactNumberField,
    SelectField,
  },
})
export default class VerificationProfile extends mixins(
  validationMixin,
  verificationStepMixin,
  screenSizeMixin,
) {
  @ProfileModule.Action('updateProfileRequest')
  updateProfileRequest!: Function

  get form() {
    return this.$refs.userBasicDetails as VFormType
  }

  previous() {
    this.$emit('previous')
  }

  async next() {
    if (this.form.validate()) {
      this.updateStore()
      await this.updateProfileRequest()
      this.$emit('next')
    }
  }
}
